module.exports = __webpack_public_path__ + "static/media/safehouse_cover.d21405c7.svg";